export default __webpack_public_path__ + "static/media/cmr-logo-b1.fda699cb.png";